export default __webpack_public_path__ + "static/media/931.627fabab.gif";